// Main application endpoints
export const WELCOME_PAGE_ENDPOINT = "/welcome";
export const MIDDLE_HANDLER_ENDPOINT = "/handle";
export const HOME_PAGE_ENDPOINT = "/";
export const SETTINGS_PAGE_ENDPOINT = "/settings";
export const PRODUCTS_PAGE_ENDPOINT = "/products";
export const WRITING_WORKSPACE_ENDPOINT = "/editor";
export const DOCUMENTS_PAGE_ENDPOINT = "/documents";
export const EXTENSION_UNINSTALLATION_PAGE_ENDPOINT = "/goodbye";
export const INTELLIWRITER_AUTH_ENDPOINT = "/intelliwriter-auth";

// Plan and subscription endpoints
export const PLAN_PAGE_ENDPOINT = "/plan";
export const PLAN_RESULT_PAGE_ENDPOINT = "/plan/result";
export const INSTITUTIONAL_SUBSCRIPTION_PAGE_ENDPOINT =
  "/institutional-subscription";

// Report endpoints
export const REPORT_LIST_PAGE_ENDPOINT = "/reports";
export const REPORT_VIEW_PAGE_ENDPOINT = "/reportview";

// User rubrics endpoints
export const USER_RUBRICS_PAGE_ENDPOINT = "/my-rubrics";

// Resource endpoints
export const RESOURCE_CONTENT_ENDPOINT = "/resource/content";
export const ARTIFACT_CONTENT_ENDPOINT = "/artifact/content";

// Admin main endpoints
export const ADMIN_PAGE_ENDPOINT = "/admin";
export const ADMIN_RUBRICS_PAGE_ENDPOINT = "/admin/rubrics";
export const ADMIN_MODELS_PAGE_ENDPOINT = "/admin/models";
export const ADMIN_ORGANIZATION_PAGE_ENDPOINT = "/admin/organization";
export const ADMIN_ORG_ADMIN_MANAGE_PAGE_ENDPOINT =
  "/admin/organization/:orgId/manage-admin";
export const ADMIN_RESOURCE_PAGE_ENDPOINT = "/admin/resource";

// Admin edit endpoints
export const ADMIN_RESOURCE_CREATE_ENDPOINT =
  "/admin/resource/:resouceId/create/edit";
export const ADMIN_RESOURCE_URL_CREATE_ENDPOINT =
  "/admin/resource/url/:resouceId/create/edit";
export const ADMIN_RESOURCE_UPDATE_ENDPOINT =
  "/admin/resource/:resouceUuid/update/edit";
export const ADMIN_TEMPLATE_EDIT_ENDPOINT =
  "/admin/template/:templateId/:action/edit";
export const ADMIN_RUBRIC_EDIT_ENDPOINT =
  "/admin/rubric/:rubricId/:action/edit";
export const ADMIN_LLM_EDIT_ENDPOINT = "/admin/llm/:llmId/:action/edit";

// Model & Rubric endpoints
export const AI_PROMPT_TEMPLATE_EDIT_PAGE_ENDPOINT = "/template";
export const AI_PROMPT_RUBRIC_EDIT_PAGE_ENDPOINT = "/rubric";
